"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18n = require("@insolus/react-i18n");

var UnderConstruction = function UnderConstruction(_ref) {
  var title = _ref.title,
      message = _ref.message,
      className = _ref.className;

  var _useTranslate = (0, _reactI18n.useTranslate)('ui-kit'),
      __ = _useTranslate.__;

  return React.createElement("div", {
    className: (0, _classnames.default)(className, 'UnderConstruction')
  }, React.createElement("h1", {
    className: "UnderConstruction__title"
  }, title || __('under-construction.work-in-progress')), React.createElement("p", {
    className: "UnderConstruction__message"
  }, message || __('under-construction.feature-in-dev')));
};

UnderConstruction.defaultProps = {
  title: undefined,
  message: undefined,
  className: undefined
};
var _default = UnderConstruction;
exports.default = _default;